export default __webpack_public_path__ + "static/horn_strobe_b.6d7c7251a0ca53298dfedb2ff91f56c0.png";